__turbopack_context__.v({
  "drawer": "WIWP8a_drawer",
  "root": "WIWP8a_root",
});
